<template>
<div class="chapter">
<div class="inner_page">
<h2 class="part"><a id="page_8"></a><a id="page_9"></a>THE ROMANTIC EGOTIST</h2>
<p class="pt"><span class="bold">1896–1913</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11_Part2.vue?6a6a6cc2